<div class="row">
    <div class="col-md-12 mt-3 ">
        <div class="col-md-12 mt-3">
            <h3>Banks supported for Instant Payouts</h3>
        </div>
        <div class="col-md-4 col-sm-8 bg-white pt-4">
            <div class="input-group border" style="width:100%">
                <input type="text" placeholder="Search" class="form-control border-0" [(ngModel)]="searchDebitBank"
                    (keyup)="getFilteredInstantPayoutSupoortBanks($event.target.value)">
                <span title="Clear" class="input-group-addon d-flex align-items-center"
                    (click)="searchDebitBank = '';getFilteredInstantPayoutSupoortBanks('');offset=99" *ngIf="searchDebitBank">
                    <mat-icon>close</mat-icon>
                </span>
            </div>
        </div>
        <div class="debit-card-list w-100 bg-white pt-4 pb-4">
            <ul>
                <li *ngFor="let d of filtered_banks | slice: 0 : offset; let i=index">
                    {{d.card_name}}
                </li>
            </ul>

            <div *ngIf="filtered_banks_count === 0">
                No records
            </div>
            <div class="col-md-12 mt-3 float-left w-100 text-center" *ngIf="filtered_banks_count > 99 && offset < filtered_banks_count">
                <a class="text-primary-custom" (click)="offset = offset + 99">View More</a>
            </div>
        </div>
        
      
    </div>
</div>